import PostScreen from './PostScreen';

export default PostScreen;
